import { Box, Grid, makeStyles } from '@material-ui/core';
import { observer } from 'mobx-react';
import { LeverageFormStore } from '../../stores/fixFlip/leverageFormStore';
import { sum } from '../../utils/utils';
import { StepTitle } from '../common/stepTitle';
import { IQuoteTypeStore } from '../../stores/common/iQuoteTypeStore';

const useStyles = makeStyles(theme => ({
  label: {
    fontWeight: 'bold',
    fontSize: '1rem',
  },
  activeLabel: {
    color: theme.palette.primary.main,
  },
  inactiveLabel: {
    color: theme.palette.text.secondary,
  },
}));

export interface LeverageCardProps {
  store: LeverageFormStore;
  disabled: boolean;
  quoteTypeStore: IQuoteTypeStore;
}

interface LeverageStepProps {
  store: IQuoteTypeStore;
  LeverageCard: React.FC<LeverageCardProps>;
}

export const LeverageStep = observer(
  ({ store, LeverageCard }: LeverageStepProps) => {
    const classes = useStyles();
    const { loanEconomicsStore } = store;

    return (
      <>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <StepTitle
              title={<>Leverage</>}
              subtitle={
                <>
                  Below in green is the maximum leverage we can offer based on
                  the borrower's FICO score and experience. You can adjust this
                  using the (+) and (-) buttons or request leverage if desired.
                </>
              }
            />
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" flexDirection={'row'} alignItems={'center'}>
              <Box style={{ cursor: 'pointer', flexGrow: 1 }}>
                <LeverageCard
                  store={loanEconomicsStore.leverageFormStore as any}
                  disabled={false}
                  quoteTypeStore={store}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </>
    );
  }
);
